import React from "react";

const styles = {
  accepting: {
    label: "Accepting Patients",
    className:
      "bg-emerald-50 text-emerald-700 border border-emerald-200",
  },

  likely_accepting: {
    label: "Likely Accepting",
    className:
      "bg-blue-50 text-blue-700 border border-blue-200",
  },

  unknown: {
    label: "Call to Confirm",
    className:
      "bg-amber-50 text-amber-700 border border-amber-200",
  },

  not_accepting: {
    label: "Not Accepting",
    className:
      "bg-rose-50 text-rose-700 border border-rose-200",
  },

  walkin: {
    label: "Walk-in Clinic",
    className:
      "bg-violet-50 text-violet-700 border border-violet-200",
  },
};

export const StatusBadge = ({ status, size = "md" }) => {
  const current = styles[status] || styles.unknown;

  const sizeClasses =
    size === "lg"
      ? "px-4 py-2 text-sm rounded-2xl"
      : "px-3 py-1 text-xs rounded-full";

  return (
    <span
      className={`inline-flex items-center font-semibold shadow-sm ${sizeClasses} ${current.className}`}
    >
      <span className="w-2 h-2 rounded-full bg-current opacity-70 mr-2" />
      {current.label}
    </span>
  );
};
